// extracted by mini-css-extract-plugin
export default {"queryContainer":"orders_queryContainer__3i6NN","queryButton":"orders_queryButton__0W5LT"};